import React from 'react';
import { Col } from 'react-bootstrap';
import { CustomImageHandler } from '../../../../../shared/components/CustomImageHandler';
import { IUserManagement } from './dto/ICampaignManagement';
import { User } from '../../../../../model/user/User';
import { UserRoles } from '../../../../../enum/UserRoles';
import { formatGroupOptions } from '../../../../../shared/functions/Functions';
import { useSelector } from 'react-redux';
import { IAllStates } from '../../../../../store/rootReducer';
import { useTranslation } from 'react-i18next';
import TooltipOverlay from '../../../../../shared/components/tooltip/Tooltip';

interface ICampaignManagementUserProps {
    user: IUserManagement;
    brandCompany: User | undefined;
    classParent?: string;
    showCrown?: boolean;
    hidePosition?: boolean;
    hasMultipleUsers?: boolean;
}

export function CampaignManagementUser({
    user,
    brandCompany,
    classParent,
    showCrown = true,
    hidePosition = false,
    hasMultipleUsers,
}: ICampaignManagementUserProps) {
    const locale = useSelector((state: IAllStates) => state.auth.user.locale);
    const isDe = locale === 'de';
    const formattedOptions = formatGroupOptions(user?.groups, isDe);
    const truncatedOptions = formatGroupOptions(user?.groups, isDe, 30, true);
    const isGroupTruncated = formattedOptions?.length > 30;
    const { t } = useTranslation();
    return (
        <Col className={`${classParent ?? 'col-md col-12'}`}>
            <div className="d-flex align-items-center">
                <div className="position-relative">
                    <CustomImageHandler
                        altTag="User Profile"
                        classes="user-placeholder mr-3"
                        photoPath={user?.profilePhoto?.thumbnail as string}
                        name={user?.firstName}
                    />
                    {user?.userType === UserRoles.BRAND_MASTER && showCrown && (
                        <div
                            className="position-absolute bg-primary upload-icon"
                            style={{ width: 20, height: 20, top: -6, right: 8 }}
                        >
                            <i className="text-white fi fi-rr-crown" style={{ height: 15 }}></i>
                        </div>
                    )}
                </div>
                <div className={`${!hasMultipleUsers && 'd-flex flex-wrap align-items-center'}`}>
                    <h5 className="mb-0 font-weight-bold">
                        {user?.firstName} {user?.lastName}
                    </h5>
                    {user?.position && !hidePosition && (
                        <div className={`text-primary ${!hasMultipleUsers && 'px-2'}`}>
                            {t(`general.positions.${user?.position}`)}
                        </div>
                    )}
                    {!!user?.groups?.length && (
                        <TooltipOverlay content={isGroupTruncated ? formattedOptions : ''}>
                            <p className="mb-0 text-muted">{truncatedOptions || '-'}</p>
                        </TooltipOverlay>
                    )}
                    {/*<div className="text-primary">{user?.brandCompany?.displayName ?? brandCompany?.displayName}</div>*/}
                    {/*<div className="text-muted font-14">{user?.isPhoneShown && (user?.contact?.phone || '')}</div>*/}
                </div>
            </div>
        </Col>
    );
}
